import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { Context } from '../../../index'
import { UserBonuses } from '../UserBonuses/UserBonuses'
import Addresses from './Addresses/Addresses'
import Favorites from './Favorites/Favorites'
import MyOffers from './MyOffers/MyOffers'
import UserInfo from './userinfo/UserInfo'

const ContentArea = observer((props) => {
	const { user } = useContext(Context)

	return (
		<div className={'user_personal_content'}>
			<UserInfo active={user.currentPage === 'profile' ? 'active' : 'hidden'} />
			{user.currentPage === 'bonuses' && <UserBonuses />}
			<Favorites
				// elementRef={props.elementRef}
				// elementRefOneCards={props.elementRefOneCards}
				active={user.currentPage === 'favorites' ? 'active' : 'hidden'}
			/>
			<MyOffers active={user.currentPage === 'order' ? 'active' : 'hidden'} />
			{/*{user.currentPage === 'addresses' && (
				<div active={user.currentPage === 'addresses' ? 'active' : 'hidden'}>
					<Addresses />
				</div>
			)}*/}

			{/*<ConsultantChat*/}
			{/*    active={user.currentPage === "callmanager" ? "active" : "hidden" }*/}
			{/*/>*/}
		</div>
	)
})

export default ContentArea
